module.exports = {
    title: 'Holiday Bonus',
    lotteryName: 'Idaho Lottery',
    promotion_id: '1555',
    promotion: 'holidaybonus',
    appUrl: '/holidaybonus',
    uathost: 'id.uat.secondchancebonuszone.com',
    prodhost: 'id.secondchancebonuszone.com',
    lotteryUrl: 'https://idaholottery.com/',
    loginLink: 'https://vip.idaholottery.com/Users/Account/LogOn',
    registerLink: 'https://vip.idaholottery.com/Users/Account/Register',
    accountLink: 'https://vip.idaholottery.com/Users/Account/LogOn',
    forgotLink:
        'https://vip.idaholottery.com/Users/Account/RequestLostPassword',
    routes: {
        login: 'scbzApi.login',
        logout: 'scbzApi.logout',
        enterDrawTicket: 'scbzApi.enterDrawTicket',
        getEntries: 'scbzApi.getEntries',
        getPlayerData: 'scbzApi.getPlayerData',
        setEntryFlashGameFlag: 'scbzApi.setEntryFlashGameFlag',
        update: 'fauxScbzApi.update',
        register: 'fauxScbzApi.register',
        getWinners: 'scbzApi.getWinners',
        getCsrfToken: 'fauxScbzApi.getCsrfToken',
        postFeedback: 'fauxScbzApi.postFeedback',
        forgotPassword: 'fauxScbzApi.forgotPassword',
        getGame: 'fauxScbzApi.getGame',
        getGameOver: 'fauxScbzApi.getGameOver',
    },
    tickets: [
        {
            value: '1555',
            label: '$1 Reindeer Riches (1555)',
            price: '1',
            entriesRange: '1 - 5',
        },
        {
            value: '1556',
            label: '$2 Gnome for the Holidays (1556)',
            price: '2',
            entriesRange: '2 - 10',
        },
        {
            value: '1557',
            label: '$3 Candy Cane Cashword (1557)',
            price: '3',
            entriesRange: '3 - 15',
        },
        {
            value: '1558',
            label: '$5 Rebel Without a Claus (1558)',
            price: '5',
            entriesRange: '5 - 25',
        },
        {
            value: '1559',
            label: '$5 Holiday Sparkle (1559)',
            price: '5',
            entriesRange: '5 - 25',
        },
        {
            value: '1560',
            label: '$20 Merry Money (1560)',
            price: '20',
            entriesRange: '20 - 40',
        },
    ],
    adrum: {
        uat: 'EUM-AAB-AXF',
        prod: 'EUM-AAB-AXE',
    },
    development: {
        testing: {
            enabled: false,
            // props: true || false || null (keep original value)
            gameOver: null,
            showGameTestButton: null,
        },
        logging: false,
    },
};
